import { setupBookingBar } from '../components/controls/bookingBar'
import { Logger } from './Logger'

export class LazyLoader {
  constructor (elem, callback) {
    this.elem = elem
    this.logger = new Logger('Booking bar loader')
    this.component = this.elem.dataset.lazyComp
    this.culture = this.elem.dataset.culture || 'en-GB'
    this.initialise = this.getContent.bind(this)
    this.setupEvents()
    this.scrollTimeout = null
  }

  setupEvents () {
    window.addEventListener('scroll', this.initialise)
  }

  getContent () {
    this.logger.log('getting content')
    this.logger.log(this.culture)
    window.removeEventListener('scroll', this.initialise)
    if (this.elem.hasAttribute('data-loading')) {
      fetch(this.component, {
        headers: {
          'Accept-Language': this.culture
        }
      })
        .then((response) => response.text())
        .then((htmlContent) => {
          this.elem.innerHTML = htmlContent
          this.elem.removeAttribute('data-loading')
          setupBookingBar(document)
        })
    }
  }
}

export const setupLazyLoaders = function (parent) {
  const elems = parent.querySelectorAll('[data-lazy-comp]')
  const lazyLoaders = []

  for (const elem of elems) {
    const lazyLoader = new LazyLoader(elem)
    lazyLoaders.push(lazyLoader)
    lazyLoader.scrollTimeout = setTimeout(() => {
      if (lazyLoader.elem.hasAttribute('data-loading')) {
        lazyLoader.getContent()
      }
    }, 1000)
  }

  return lazyLoaders
}
